<div class="form-editor mt-5">
    <eas-workflow-form-field-list
        [items]="availableFields"
        (addField)="onAddFormField()"
        (editField)="onEditFormField($event)"
        (setPermission)="onSetFormFieldPermission($event)"
        (removePermission)="onRemoveFormFieldPermission($event)"
        (moveFieldUp)="onMoveFieldUp($event)"
        (moveFieldDown)="onMoveFieldDown($event)"
        (dropField)="onDropField($event)"
        class="form-editor-list">
    </eas-workflow-form-field-list>
    <eas-workflow-form-preview (setPermissionForAllFields)="onSetPermissionForAllFields($event)"
                               class="form-editor-preview">
    </eas-workflow-form-preview>
</div>
